import * as types from "../action-types.js";

const initState = {
  themeStatus: localStorage.getItem("theme") || "moon",
  uploadSuccessTotal: 0,
  uploadStatus: "not-upload", // not-upload uploading upload-complete
};
export default (state = initState, { type, data }) => {
  switch (type) {
    case types.ADD_NUMBER:
      return {
        ...state,
        uploadSuccessTotal: state.uploadSuccessTotal + data,
      };
    case types.RESET_NUMBER:
      return {
        ...state,
        uploadSuccessTotal: initState.uploadSuccessTotal,
      };
    case types.PATCH_UPLOAD_STATUS:
      return {
        ...state,
        uploadStatus: data,
      };
    case types.THEME_STATE:
      return {
        ...state,
        themeStatus: data,
      };
    default:
      return state;
  }
};
